import { render, staticRenderFns } from "./yjl-loading.vue?vue&type=template&id=38ca2a71&scoped=true"
import script from "./yjl-loading.vue?vue&type=script&lang=js"
export * from "./yjl-loading.vue?vue&type=script&lang=js"
import style0 from "./yjl-loading.vue?vue&type=style&index=0&id=38ca2a71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ca2a71",
  null
  
)

export default component.exports